exports.f = Object.getOwnPropertySymbols;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_object-gops.js
 ** module id = 702
 ** module chunks = 0
 **/